// Swap these two URLs for the real Freshly store listings at launch.
export const APP_STORE_URL = "https://apps.apple.com/";
export const PLAY_STORE_URL = "https://play.google.com/store/apps";
// Launch moment — countdown in the hero flips to store badges when this passes.
export const LAUNCH_DATE = "2026-10-01T09:00:00-06:00";
